<template>
    <div>
        <TipsAlert :tipswords="masterTips.tipswords"
                   :status="masterTips.status"
                   :videostatus="masterTips.videostatus"
                   :videosrc="masterTips.videosrc">

        </TipsAlert>
        <b-card no-body :header="title" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">
            <div class="d-flex justify-content-between align-items-center p-2">

                <div class="w-25 text-center" style="min-width: 70px"><h5 class="text-primary">{{ mainName }}</h5>{{Apercent}}%</div>
                <b-progress class="w-100"   >
                    <b-progress-bar  :value="Apercent" :variant="Apercent>Bpercent?'primary':'secondary'" striped :animated="Apercent>Bpercent"></b-progress-bar>
                    <b-progress-bar :value="Bpercent" :variant="Apercent<Bpercent?'warning':'secondary'" striped :animated="Apercent<Bpercent"></b-progress-bar>
                </b-progress>
                <div class="w-25 text-center" style="min-width: 70px"><h5 class="text-primary">{{ secName }}</h5>{{Bpercent}}%</div>

            </div>
            <h5 class="text-center text-primary">{{Winner.result}}</h5>

            <div v-if="Winner.name==''?false:true">
                <p class="px-3 text-primary">{{ Winner.name }} 的強勢分析</p>
                <div class="p-3 border-top"  v-for="(item , index) in Result" v-bind:key="index">
                    <img class="redS" :src="require('../assets/ui/red.png')">  {{item.result }}
                </div>

            </div>

        </b-card>

    </div>

</template>

<script>
import TipsAlert from '@/components/TipsAlert.vue'

export default {
  name: 'SwitchResultCard',
  components: {TipsAlert},

  props: {
    title:String,
    mainName:String,
    secName:String,
    data:Object

  },
  computed: {
   Apercent:function () {
     return this.data.Origan.Apercent;
   },
    Bpercent:function () {
      return this.data.Origan.Bpercent;
    },
    Result:function () {
      return this.data.explantion;
    },
    Winner:function () {
     let apercent=this.data.Origan.Apercent;
      let bpercent=this.data.Origan.Bpercent;

      let returnData = ''
      let winnername = ''
      if (apercent > bpercent) {
        returnData = this.mainName+" 較佔上風";
        winnername =  this.mainName
      }else if (apercent < bpercent) {
        returnData = this.secName+" 較佔上風";
        winnername =  this.secName
      }else if (apercent == bpercent) {
        returnData = "雙方互不相讓";
      }

      return {name:winnername,result:returnData};

    }
  },
  data () {
    return {
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'',
        tipswords:'（誰佔上風）在談判或銷售上，有時會搞不清楚，主要溝通對象是誰，這是就可以使用此項目，找出比較有可能的決策者，這對未來成交率，絕對能提升很多。',
      },
    }
  },
  methods: {


  }
}
</script>
